import App from './App.svelte';
import { mount, unmount } from 'svelte';

class DadosWidget {
  constructor(options) {
    this.options = options;
    this.app = null;
    this.init();
  }

  init() {
    try {
      const target = this.options.target;
      
      if (!target) {
        throw new Error('Target element não encontrado');
      }

      // Aguardar o DOM estar completamente pronto
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.createApp();
        });
      } else {
        // DOM já está pronto, mas vamos dar um delay maior para garantir
        setTimeout(() => {
          this.createApp();
        }, 200);
      }

    } catch (error) {
      console.error('Erro ao inicializar widget:', error);
      throw error;
    }
  }

  createApp() {
    try {
      // Verificar se o target ainda existe
      if (!this.options.target || !this.options.target.parentNode) {
        throw new Error('Target element não encontrado ou removido');
      }

      // Usar mount do Svelte 5 para criar a aplicação
      this.app = mount(App, {
        target: this.options.target,
        props: this.options.props || {}
      });

      console.log('Widget inicializado com sucesso');
    } catch (error) {
      console.error('Erro ao criar app Svelte:', error);
      throw error;
    }
  }

  destroy() {
    if (this.app) {
      try {
        unmount(this.app);
      } catch (error) {
        console.error('Erro ao destruir widget:', error);
      }
      this.app = null;
    }
  }
}

// Exportar para uso como módulo ES6
export default DadosWidget;

// Também disponibilizar globalmente para compatibilidade
if (typeof window !== 'undefined') {
  window.DadosWidget = DadosWidget;
}
